<template>
    <div class="d-flex flex-column fill-height" id="campaigns_list">
        <v-overlay :value="isPageLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row ref="headerFilters" class="flex-grow-0">
            <data-table-filters  v-if="!isMobile"
                name="Campanhas"
                :has-active-filters="hasActiveFilters"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :filters="filters"
                :schema="schema"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh()"
                @clear-filters="onClearFilters()"
            >
            </data-table-filters>
            <div class="col wrap-title-filters" v-else >
                <filters-dialog
                        name="Campanhas"
                        :has-active-filters="hasActiveFilters"
                        :has-expanded-active-filters="hasExpandedActiveFilters"
                        :filters="filters"
                        :schema="schema"
                        @expand-active-filters="hasExpandedActiveFilters = $event"
                        @remove-filter="removeFilter"
                        @refresh="refresh()"
                        @clear-filters="onClearFilters()"
                    >
                </filters-dialog>
            </div>
        </v-row>

        <v-row>
            <v-col>
                <portal to="v-form-base">
                    <v-form-base :model="filters" :schema="schema" @input="onFiltersChanged"></v-form-base>
                </portal>

                <app-card class="d-flex flex-column align-stretch fill-height py-4 px-4">
                    <template v-slot:image>
                        <div class="d-flex justify-center">
                            <v-tabs show-arrows centered id="myprovet-tabs" v-model="selectedTab.index" next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" height="35px" style="border-radius: 8px; padding-left: 11px">
                                <v-tabs-slider color="#154579"></v-tabs-slider>

                                <v-tab class="myprovet-tab-item" v-for="item in tabItems" :key="item.tab">
                                    {{ item.tab }}
                                </v-tab>
                            </v-tabs>
                        </div>

                        <loading-indicator v-if="isLoading" :loading="isLoading"> </loading-indicator>

                        <template v-else-if="campaigns.items.length > 0">
                            <div class="d-flex fill-height justify-space-between">
                                <div class="d-flex align-center">
                                    <v-btn :disabled="campaigns.currentPage === 1" icon elevation="1" class="mr-3 appbar-icon-button btn-bg-color-blue dark-blue-color" @click="changeCampaignPage(-1)">
                                        <v-icon>mdi-arrow-left</v-icon>
                                    </v-btn>
                                </div>

                                <div class="d-flex align-center" style="width: 100%">
                                    <v-container fluid>
                                        <v-row dense>
                                            <v-col v-for="campaign in campaigns.items" :key="campaign.id" cols="3">
                                                <v-card>
                                                    <v-img :src="campaign.src" class="white--text align-end" gradient="to bottom, rgba(21,69,121,.8), rgba(21,69,121,.5)" height="200px">
                                                        <v-card-title v-text="campaign.name" class="font-size-lg"></v-card-title>
                                                        <v-card-subtitle v-text="campaign.description" class="font-size-sm"></v-card-subtitle>
                                                    </v-img>

                                                    <v-card-actions>
                                                        <v-row dense>
                                                            <v-col cols="12">
                                                                <div class="d-flex justify-center">
                                                                    <v-btn text class="myprovet-btn-ok" @click="onOpenDetailedCampaignDialog(campaign)" v-html="isMobile?'Ver':'Ver Campanha'"> </v-btn>
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </div>

                                <div class="d-flex align-center">
                                    <v-btn :disabled="!hasMoreCampaignPages" icon elevation="1" class="ml-3 appbar-icon-button btn-bg-color-blue dark-blue-color" @click="changeCampaignPage(1)">
                                        <v-icon>mdi-arrow-right</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <div class="d-flex fill-height justify-center">
                                <div class="d-flex align-center">Sem campanhas disponíveis</div>
                            </div>
                        </template>
                    </template>
                </app-card>
            </v-col>
        </v-row>

        <product-campaign-form
            v-if="isDetailedCampaignDialogOpen"
            :isOpen="isDetailedCampaignDialogOpen"
            :product="product"
            :campaigns="manipulatedProductCampaigns"
            :account-blocked-message="accountBlockedMessage"
            @input="onCloseDetailedCampaignDialog()"
            @check-applied-campaigns="checkAppliedCampaigns()"
            @create-new-original-campaign="createNewOriginalCampaign($event)"
            @show-campaigns="onClickProductCampaign"
        ></product-campaign-form>

        <app-dialog v-if="isProductDetailsDialogOpen" :value="isProductDetailsDialogOpen" @input="isProductDetailsDialogOpen = $event" title="Ficha do Produto" width="55vw" :isProductDetails="true" :isResponsive="true" :showActions="false">
            <template v-slot:content>
                <product-details :product="selectedProduct" :key="selectedProduct.id" @change-product="selectedProduct = $event" @show-campaigns="onClickProductCampaign"></product-details>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import { buildQueryObjectFromModel } from '@arentia/atools/QueryBuilder';
import MainLayout from './../../Layouts/MainLayout';
import VFormBase from 'vuetify-form-base';
import ResizeObserver from 'resize-observer-polyfill';

export default {
    layout: MainLayout,

    components: {
        VFormBase,
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        product: Object,
        accountBlockedMessage: String,
    },

    data: () => ({
        filters: {},
        hasExpandedActiveFilters: false,
        datatableSize: 200,
        resizeObserver: null,

        isPageLoading: false,
        isLoading: true,

        selectedTab: {
            id: 0,
            index: -1,
            name: '',
        },
        tabItems: [],

        campaigns: {
            currentPage: 1,
            lastPage: 1,
            items: [],
        },

        originatingProductId: 999999,
        manipulatedProductCampaigns: [],
        productCampaigns: [],
        originalProductCampaigns: [],

        selectedProduct: {},
        selectedCampaign: {},

        isDetailedCampaignDialogOpen: false,
        isProductDetailsDialogOpen: false,

        customSearch: {
            name: `{
                "type": "query-builder-group",
                "query": {
                    "logicalOperator": "any",
                    "children": [
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "name",
                                "operator": "contains",
                                "operand": "name",
                                "value": "__name__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "description",
                                "operator": "contains",
                                "operand": "description",
                                "value": "__name__"
                            }
                        }
                    ]
                }
            }`,
        },
    }),

    watch: {
        'branchStore.branch': {
            handler: function (branch) {
                if (!branch) return;

                // Return to Dashboard page if branch's no_campaigns property is true.
                if (branch && branch.no_campaigns) this.$inertia.visit('/dashboard');

                this.refresh();
            },
            immediate: true,
        },

        'selectedTab.index': {
            handler: function (index) {

                if (this.tabItems.length > 0) {
                    this.$set(this.filters, 'requirements__product__laboratory__name', this.tabItems[index]?.tab);
                    this.campaigns.currentPage = 1; // Reset the current page
                    this.onFiltersChanged();
                }
            },
            immediate: true,
        },

        tabItems: {
            handler: function (items) {

                    if (items.length > 0) {
                    if (this.selectedTab.index === -1) this.$set(this.selectedTab, 'index', 0);
                    this.$set(this.selectedTab, 'id', items[this.selectedTab.index]?.id);
                    this.$set(this.selectedTab, 'name', items[this.selectedTab.index]?.tab);
                    } else {
                        this.setDefaultSelectedTab();
                    }

            },
            immediate: true,
        },
    },

    created() {
        this.applyDefaultFilters();
    },

    mounted() {
        this.prepareResponsiveBehaviour();

        window.EventBus.$on('product-quantity-change', () => {
            if (this.isDetailedCampaignDialogOpen) {
                this.onOpenDetailedCampaignDialog(this.selectedCampaign);
            }
        });
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useNormalOrderStore,useAppStore),

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        hasMoreCampaignPages() {
            return this.campaigns.currentPage < this.campaigns.lastPage;
        },
        isMobile(){
            return this.appStore.is_mobile;
        },
    },

    methods: {
        prepareResponsiveBehaviour() {
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);

            window.addEventListener('resize', makeResponsive);

            makeResponsive();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 158 - topHeight;
                this.datatableSize = res;
            }
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);
            this.onFiltersChanged();
        },

        onFiltersChanged() {
            setTimeout(() => {
                this.refresh();

                window.EventBus.$emit('check-if-should-overflow');
                window.EventBus.$emit('check-if-should-underflow');
            }, 300);
        },

        refresh() {
            if (!this.branchStore.branch) return;
            if (!this.hasActiveFilters) this.selectedTab.index = 0;

            this.getCampaigns();
        },

        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        onClearFilters() {
            this.applyDefaultFilters();
            this.hasExpandedActiveFilters = false;

            this.refresh();
        },

        changeCampaignPage(amount) {
            const nextPage = this.campaigns.currentPage + amount;

            if (nextPage < 1 || nextPage > this.campaigns.lastPage) {
                return;
            }

            this.campaigns.currentPage = nextPage;
            this.getCampaigns();
        },

        onClickProductCampaign(product) {
            this.isProductDetailsDialogOpen = false;
            this.isDetailedCampaignDialogOpen = false;

            this.selectedProduct = product;
            this.getSelectedProductCampaigns();
        },

        getCampaigns() {
            this.isLoading = true;

            if (!this.campaigns) {
                this.campaigns.currentPage = 1;
                this.campaigns.lastPage = 1;
            }

            const query = buildQueryObjectFromModel(this.filters, this.schema, { customSearch: this.customSearch });

            axios
                .get('/api/campaigns/simple', {
                    params: {
                        branch_id: this.branchStore.branch?.id,
                        page: this.campaigns.currentPage,
                        queryObject: JSON.stringify(query),
                    },
                })
                .then((response) => {
                    console.log('response',response)
                    this.isLoading = false;
                    this.campaigns.currentPage = response.data.currentPage;
                    this.campaigns.lastPage = response.data.lastPage;
                    this.campaigns.items = response.data.campaigns;
                    this.tabItems = response.data.tabs;
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },

        getSelectedProductCampaigns() {
            this.isPageLoading = true;

            axios
                .get('/api/campaigns', {
                    params: {
                        reference: this.selectedProduct.code,
                        branch_id: this.branchStore.branch?.id,
                        campaign_id: this.selectedProduct.campaign_id,
                    },
                })
                .then((response) => {
                    this.isPageLoading = false;
                    this.productCampaigns = response.data;
                    this.originalProductCampaigns = JSON.parse(JSON.stringify(this.productCampaigns));

                    if (this.productCampaigns.length == 0) {
                        this.showError('Campanhas do produto temporariamente indisponíveis. Por favor volte a tentar mais tarde ...');
                    } else {
                        this.checkAppliedCampaigns();
                        this.isDetailedCampaignDialogOpen = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isPageLoading = false;
                });
        },

        handleStoredMixCampaigns() {
            // Check if there are stored mixs to show
            let campaigns = [];
            const all_stored_campaigns = this.normalOrderStore.getSimpleCampaigns;

            if (all_stored_campaigns.length > 0) {
                this.productCampaigns.forEach((campaign) => {
                    const stored_campaigns = all_stored_campaigns.filter((sc) => {
                        return sc.id === campaign.id;
                    });

                    if (stored_campaigns.length > 0) {
                        stored_campaigns.forEach((stored_campaign) => {
                            campaigns.push(stored_campaign);
                        });
                    } else {
                        campaigns.push(campaign);
                    }
                });
            }

            this.manipulatedProductCampaigns =
                campaigns.length > 0 //
                    ? campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index)
                    : this.productCampaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },

        checkAppliedCampaigns() {
            let campaigns = [];
            this.originalProductCampaigns = JSON.parse(JSON.stringify(this.productCampaigns));

            this.handleStoredMixCampaigns();

            this.manipulatedProductCampaigns.forEach((campaign) => {
                let storedCampaign = this.normalOrderStore.getCampaignByUniqueId(campaign.unique_id);

                if (storedCampaign) {
                    campaigns.push(storedCampaign);
                } else {
                    let storedCampaignFromAnotherRequirement = this.normalOrderStore.getCampaignByUniqueId(campaign.unique_id);

                    if (storedCampaignFromAnotherRequirement && storedCampaignFromAnotherRequirement.unique_id == campaign.unique_id) {
                        campaigns.push(storedCampaignFromAnotherRequirement);
                    } else {
                        const originalCampaign = JSON.parse(JSON.stringify(this.originalProductCampaigns.find((c) => c.id == campaign.id)));
                        campaigns.push(originalCampaign);
                    }
                }
            });

            this.manipulatedProductCampaigns = campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },

        setDefaultSelectedTab() {
            this.selectedTab.index = -1;
            this.selectedTab.id = 0;
            this.selectedTab.name = '';
        },

        onOpenDetailedCampaignDialog(campaign) {
            this.selectedCampaign = campaign;
            this.selectedProduct = this.product;

            // Flush productCampaigns and push the new selected campaign
            this.productCampaigns.splice(0);
            this.productCampaigns.push(campaign);

            this.checkAppliedCampaigns();

            this.isDetailedCampaignDialogOpen = true;
        },

        onCloseDetailedCampaignDialog() {
            this.isDetailedCampaignDialogOpen = false;
        },

        createNewOriginalCampaign(campaign) {
            let campaigns = [];

            const newOriginalCampaign = () => {
                const originalCampaign = this.campaigns.items.find((c) => {
                    return c.id == campaign.id;
                });

                if (!originalCampaign) return false;

                const maxIndexCampaign = this.manipulatedProductCampaigns.filter((c) => c.id === campaign.id).reduce((prev, current) => (prev && prev.index > current.index ? prev : current));

                let oc = originalCampaign;
                oc.index = maxIndexCampaign.index + 1;
                oc.unique_id = oc.id + '_' + oc.index;

                // Manipulate requirements unique_id
                oc.requirements.forEach((requirement, index) => {
                    requirement.campaign_unique_id = oc.unique_id;
                    requirement.product.campaign_unique_id = oc.unique_id;
                    requirement.product.uniqueId = requirement.product.id + '_' + oc.unique_id + '_header_' + index;
                });

                // Manipulate requirements unique_id
                oc.offers.forEach((offer, index) => {
                    offer.campaign_unique_id = oc.unique_id;
                    offer.product.campaign_unique_id = oc.unique_id;
                    offer.product.uniqueId = offer.product.id + '_' + oc.unique_id + '_offer_' + index;
                });

                return oc;
            };

            this.manipulatedProductCampaigns.forEach((manipulatedCampaign) => {
                campaigns.push(manipulatedCampaign);

                if (manipulatedCampaign.unique_id === campaign.unique_id) {
                    campaigns.push(JSON.parse(JSON.stringify(newOriginalCampaign())));
                }
            });

            this.manipulatedProductCampaigns = campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },
    },
};
</script>

<style>
.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}

#form-base > div > .v-input > .v-input__control > .v-input__slot .v-input__icon--prepend-inner button.v-icon {
    color: #154579;
    font-size: 18px !important;
}
</style>
